module.exports = __webpack_public_path__ + "img/product3.dd16cf7.webp";